export const NAMESPACE = 'KanBo/users/'
export const ADD = NAMESPACE + 'ADD'
export const ADD_ARRAY = NAMESPACE + 'ADD_ARRAY'
export const SET_USER = NAMESPACE + 'SET_USER'
export const SET_PROFILE_BY_PROFILE_KEY = NAMESPACE + 'SET_PROFILE_BY_PROFILE_KEY'
export const SET_USER_BY_PROFILE_KEY = NAMESPACE + 'SET_USER_BY_PROFILE_KEY'

const initialState = {}

export const userDefaults = {
  email: null,
  name: null,
  profileKey: null,
  licenseType: null,
  isActive: true,
  isLoading: false,
  isLoaded: false,
  profile: {
    isLoading: false,
    isLoaded: false
  }
}

export default function reducer (state = initialState, action = {}) {
  switch (action.type) {
    case ADD:
      return {
        ...state,
        [action.payload.id]: {
          ...userDefaults,
          ...state[action.payload.id],
          ...action.payload
        }
      }
    case ADD_ARRAY: {
      const newState = {
        ...state
      }
      action.payload.forEach(user => {
        newState[user.id] = {
          ...userDefaults,
          ...newState[user.id],
          ...user
        }
      })
      return newState
    }
    case SET_USER:
      return state[action.payload.id] ? {
        ...state,
        [action.payload.id]: {
          ...state[action.payload.id],
          ...action.payload
        }
      } : state
    case SET_PROFILE_BY_PROFILE_KEY: {
      let user = null

      const ids = Object.keys(state)
      const length = ids.length
      for (let i = 0; i < length; i++) {
        const _user = state[ids[i]]
        if (_user.profileKey === action.payload.profileKey) {
          user = _user
          break
        }
      }

      if (!user) return state

      return {
        ...state,
        [user.id]: {
          ...user,
          profile: {
            ...user.profile,
            ...action.payload.profile,
            fields: {
              ...((user.profile && user.profile.fields) ? user.profile.fields : null),
              ...action.payload.profile.fields
            }
          }
        }
      }
    }
    case SET_USER_BY_PROFILE_KEY: {
      let user = null

      const ids = Object.keys(state)
      const length = ids.length
      for (let i = 0; i < length; i++) {
        const _user = state[ids[i]]
        if (_user.profileKey === action.payload.profileKey) {
          user = _user
          break
        }
      }

      if (!user) return state

      return {
        ...state,
        [user.id]: {
          ...user,
          ...action.payload.data
        }
      }
    }
    default: return state
  }
}

export function add (data) {
  return {
    type: ADD,
    payload: data
  }
}

export function addArray (usersArray) {
  return {
    type: ADD_ARRAY,
    payload: usersArray
  }
}

export function setUser (data) {
  return {
    type: SET_USER,
    payload: data
  }
}

export function setProfileByProfileKey ({ profileKey, profile }) {
  return {
    type: SET_PROFILE_BY_PROFILE_KEY,
    payload: {
      profileKey,
      profile
    }
  }
}

export function setUserByProfileKey ({ profileKey, data }) {
  return {
    type: SET_USER_BY_PROFILE_KEY,
    payload: {
      profileKey,
      data
    }
  }
}